import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import ArticleSection from './components/ArticleSection';
import SEOData from '@/components/feature/SEOData';

export default function Home() {
  return (
    <>
      <SEOData
        pageTitle="妈妈的朋友在线观看·完整版高清免费播放 - 影视资讯平台"
        pageDescription="妈妈的朋友影视平台提供高清影视资讯、深度影评和观影指南。涵盖电影推荐、影评解析、剧集追踪、经典回顾等板块，收录正版授权片源，手机电脑多端免费观看。"
        canonicalPath="/"
        pageType="website"
        breadcrumbs={[{ name: '首页', url: 'https://mamadepengyou.com' }]}
        faqs={[
          {
            question: '妈妈的朋友在线观看是否免费？',
            answer: '是的，妈妈的朋友影视平台提供免费的影视资讯和影评内容浏览服务，用户无需付费即可阅读所有文章和影评。',
          },
          {
            question: '妈妈的朋友平台支持哪些设备观看？',
            answer: '妈妈的朋友平台支持手机、平板、电脑等多端访问，自适应各种屏幕尺寸，随时随地畅享影视内容。',
          },
          {
            question: '如何找到妈妈的朋友高清完整版资源？',
            answer: '您可以在妈妈的朋友平台浏览详细的影视介绍和观影指南，平台提供专业的影视推荐和深度影评，帮助您发现优质影视内容。',
          },
          {
            question: '妈妈的朋友平台更新频率如何？',
            answer: '妈妈的朋友平台每日更新多篇优质影视内容，包括最新电影推荐、深度影评解析、剧集追踪和行业资讯，确保内容及时新鲜。',
          },
        ]}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <ArticleSection />
      </main>
      <Footer />
    </>
  );
}